export const AI_OVERVIEW_MODE_AUTO = 'auto';
export const AI_OVERVIEW_MODE_ON = 'on';
export const AI_OVERVIEW_MODE_OFF = 'off';

export const AI_OVERVIEW_MODE_STORAGE_KEY = 'pcific_ai_overview_mode';

const VALID_AI_OVERVIEW_MODES = [AI_OVERVIEW_MODE_AUTO, AI_OVERVIEW_MODE_ON, AI_OVERVIEW_MODE_OFF];
const AI_OVERVIEW_BASE_PARAM_KEYS = ['ai_overview'];

const NATURAL_LANGUAGE_PATTERN = /\b(find|show|need|want|looking for|look for|help me|best|recommend|search for|under|over|between|around|for|with)\b/i;
const COMPARE_PATTERN = /\b(vs|versus|compare|better)\b/i;
const STORAGE_PATTERN = /\b\d+(?:gb|tb)\b/i;
const PRICE_PATTERN = /(?:£|\$|€)\s?\d+|\b(?:under|over|below|above)\s+\d+\b/i;
const CONDITION_PATTERN = /\b(used|new|brand new|refurbished|refurb|mint|good|fair|excellent|spares|repairs|broken|locked|unlocked|sim free)\b/i;

export const normalizeAiOverviewMode = mode =>
  VALID_AI_OVERVIEW_MODES.includes(mode) ? mode : AI_OVERVIEW_MODE_AUTO;

export const getStoredAiOverviewMode = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return AI_OVERVIEW_MODE_AUTO;
  }

  try {
    return normalizeAiOverviewMode(window.localStorage.getItem(AI_OVERVIEW_MODE_STORAGE_KEY));
  } catch (_) {
    return AI_OVERVIEW_MODE_AUTO;
  }
};

export const setStoredAiOverviewMode = mode => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  try {
    window.localStorage.setItem(AI_OVERVIEW_MODE_STORAGE_KEY, normalizeAiOverviewMode(mode));
  } catch (_) {}
};

export const shouldAutoUseAiOverview = rawQuery => {
  const query = typeof rawQuery === 'string' ? rawQuery.trim() : '';
  if (!query) return false;

  if (NATURAL_LANGUAGE_PATTERN.test(query)) return true;
  if (COMPARE_PATTERN.test(query)) return true;

  const hasStorageConstraint = STORAGE_PATTERN.test(query);
  const hasPriceConstraint = PRICE_PATTERN.test(query);
  const hasConditionConstraint = CONDITION_PATTERN.test(query);

  return hasStorageConstraint || hasPriceConstraint || hasConditionConstraint;
};

export const shouldUseAiOverviewForMode = ({ query, mode }) => {
  const normalizedMode = normalizeAiOverviewMode(mode);

  if (normalizedMode === AI_OVERVIEW_MODE_ON) return true;
  if (normalizedMode === AI_OVERVIEW_MODE_OFF) return false;
  return shouldAutoUseAiOverview(query);
};

export const sanitizeAiOverviewBaseParams = currentParams => {
  const source = currentParams && typeof currentParams === 'object' ? currentParams : {};

  return AI_OVERVIEW_BASE_PARAM_KEYS.reduce((acc, key) => {
    if (source[key] != null && source[key] !== '') {
      acc[key] = source[key];
    }
    return acc;
  }, {});
};

export const buildAiOverviewSearchParams = ({ query, mode, currentParams = {} }) => {
  const trimmedQuery = typeof query === 'string' ? query.trim() : '';
  const normalizedMode = normalizeAiOverviewMode(mode);
  const shouldUseAiOverview = shouldUseAiOverviewForMode({
    query: trimmedQuery,
    mode: normalizedMode,
  });

  const nextParams = {
    ...sanitizeAiOverviewBaseParams(currentParams),
    keywords: trimmedQuery,
    ai_overview: normalizedMode,
  };

  if (shouldUseAiOverview) {
    nextParams.ai_query = trimmedQuery;
  } else {
    delete nextParams.ai_query;
  }

  return nextParams;
};
